import { render, staticRenderFns } from "./SeleccionPuesto.vue?vue&type=template&id=2592608e&scoped=true"
import script from "./SeleccionPuesto.vue?vue&type=script&lang=js"
export * from "./SeleccionPuesto.vue?vue&type=script&lang=js"
import style0 from "./SeleccionPuesto.vue?vue&type=style&index=0&id=2592608e&prod&scoped=true&lang=css"
import style1 from "./SeleccionPuesto.vue?vue&type=style&index=1&id=2592608e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592608e",
  null
  
)

export default component.exports